<template>
    <div>

        <vue-headful title="Delete Training Course Catalog :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses/catalogs`">
                        Catalogs
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses/catalogs/view/${catalog.id}`">
                        {{ catalog.catalog_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">Delete Catalog</li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-6 col-12 mb-lg-0 mb-3">
                    <div class="card">
                        <div class="card-header">
                            Delete Catalog
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>WARNING:</strong> You are about to delete this training course catalog. The catalog will be removed from all Training Courses. This cannot be undone. Do you wish to continue?
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteCatalog()" :disabled="saving">
                                <template v-if="!saving">Yes, Delete this Training Course Catalog</template>
                                <template v-else>Deleting...</template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                errors: {},
                catalog: {},
            }
        },

        methods: {
            //Load the Account
            getCatalog(){
                //Send it
                this.$http.get('training-courses/catalogs/view/' + this.id)
                    .then(res => {
                        //Set data
                        this.catalog = res.data.catalog;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteCatalog(){
                //Doing it
                this.saving = true;

                //Send it
                this.$http.post('training-courses/catalogs/delete/' + this.id)
                    .then(res => {
                        //Catalog
                        this.$toastr.success('Training Course Catalog Deleted');

                        //Push
                        this.$router.push('/training-courses/catalogs');
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted(){
            //Get it
            this.getCatalog();
        }
    }
</script>
